import { useQuery } from '@tanstack/react-query'
import { clikArtService } from '@/api/services/clikart.service'
import { queryKeys } from '@/api/query-keys'

export function useClikArtKeywordsQuery() {
  return useQuery({
    queryKey: queryKeys.clikArt.keywords(),
    queryFn: () => clikArtService.getClikArtKeywords(),
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
